<template>
    <div class="py-4 bg-secondary">
    <div class="profile-page">
        <section class="section py-1 mb-3">
            <div class="container">
              <div class="errorpage_div">
                <img src="img/Logo_line_web_animated.svg" style="height: 300px;">
                <span class="news_title">{{$t('homepage.error_page')}}</span>
                <router-link to="/" class="mt-3 button_new_m btnnew_primary" style="display: inline-block;">
                  {{$t('app.main_page')}}
                </router-link>
              </div>
            </div>
        </section>
    </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                activeName: '1'
            };
        }
    }
</script>
<style scoped>
@import url(../assets/css/custom.scss);

.errorpage_div {
  margin-top: 150px;
  margin-bottom: 150px;
  text-align: center;
}

.button_new_m {
  display: block;
  white-space: inherit;
  line-height: 1;
  font-weight: 500;
  margin-right: 0px !important;
  margin-left: 0px !important;
}

.btnnew_primary {
  text-align: center;
  white-space: normal;
  vertical-align: middle;
  user-select: none;
  font-size: 15px;
  padding: 0.625rem 1.25rem;
  border-radius: 0px;
  color: #fff;
  background-color: #96b4d3;
  border-color: #96b4d3;
  margin-bottom: .5rem;
  box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
}
</style>
